export const COMPANY_DETAILS = "COMPANY_DETAILS";
export const EMPLOYEE_LIST = "EMPLOYEE_LIST";
export const DEPARTMENT_LIST = "DEPARTMENT_LIST";
export const SUBMIT_EXECUTIVE_LEAD = "SUBMIT_EXECUTIVE_LEAD";
export const SIMILAR_COMPANYLIST = "SIMILAR_COMPANYLIST";
export const SUBMIT_ERROR_FORM = "SUBMIT_ERROR_FORM";
export const SINGLE_COMPANY_TAG = "SINGLE_COMPANY_TAG";
export const FETCH_COMPANY_TAG = "FETCH_COMPANY_TAG";
export const POST_RELAVANT_COMPANY_TAG = "POST_RELAVANT_COMPANY_TAG";
export const GET_RELAVANT_COMPANY_TAG = "GET_RELAVANT_COMPANY_TAG";
export const SELECTED_EXECUTIVE = "SELECTED_EXECUTIVE";
export const SELECTED_DEPARTMENT = "SELECTED_DEPARTMENT";
export const GET_EXECUTIVE_LEAD = "GET_EXECUTIVE_LEAD";
export const EMPLOYEE_VIEWABLE_STATUS = "EMPLOYEE_VIEWABLE_STATUS";

export const EMPTY_ERROR_OBJ = "EMPTY_ERROR_OBJ_ERROR";
export const COMPANY_DETAILS_ERROR = "COMPANY_DETAILS_ERROR";
export const EMPLOYEE_LIST_ERROR = "EMPLOYEE_LIST_ERROR";
export const DEPARTMENT_LIST_ERROR = "DEPARTMENT_LIST_ERROR";
export const SUBMIT_EXECUTIVE_LEAD_ERROR = "SUBMIT_EXECUTIVE_LEAD_ERROR";
export const SIMILAR_COMPANYLIST_ERROR = "SIMILAR_COMPANYLIST_ERROR";
export const SUBMIT_ERROR_FORM_ERROR = "SUBMIT_ERROR_FORM_ERROR";
export const SINGLE_COMPANY_TAG_ERROR = "SINGLE_COMPANY_TAG_ERROR";
export const DOWNLOAD_COMPANY_ERROR = "DOWNLOAD_COMPANY_ERROR";
export const FETCH_COMPANY_TAG_ERROR = "FETCH_COMPANY_TAG_ERROR";
export const POST_RELAVANT_COMPANY_TAG_ERROR =
  "POST_RELAVANT_COMPANY_TAG_ERROR";
export const GET_RELAVANT_COMPANY_TAG_ERROR = "GET_RELAVANT_COMPANY_TAG_ERROR";
export const DOWNLOAD_EXECUTIVE_ERROR = "DOWNLOAD_EXECUTIVE_ERROR";
export const GET_EXECUTIVE_LEAD_ERROR = "GET_EXECUTIVE_LEAD_ERROR";
export const EMPLOYEE_VIEWABLE_STATUS_ERROR = "EMPLOYEE_VIEWABLE_STATUS_ERROR";
